<template>
  <div class="tradeSearch">
    <el-form :inline="true" :model="form" class="tradeSearch-form" ref="form">
      <el-form-item label="订单编号">
        <el-input v-model="form.id" placeholder="请输入订单编号"></el-input>
      </el-form-item>
      <el-form-item label="名称">
        <el-input v-model="form.userName" placeholder="请输入用户名称"></el-input>
      </el-form-item>
      <el-form-item label="金额">
        <el-input v-model="form.amount" type="number" placeholder="请输入金额"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="form.type" placeholder="请选择账单类型">
          <el-option label="全部" value="0"></el-option>
          <el-option label="支出" value="1"></el-option>
          <el-option label="收入" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item class="efi" label="支付渠道:">
            <el-select v-model="form.payType" placeholder="请选支付渠道">
              <el-option label="全部" value="0"></el-option>
              <el-option label="微信" value="2"></el-option>
              <el-option label="支付宝" value="3"></el-option>
              <el-option label="润泽钱包" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间范围">
            <!-- <el-date-picker
              v-model="form.range"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            ></el-date-picker> -->
            <el-date-picker style="width: 100%;" v-model="form.range" @change="handleTimeChange"
              format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" type="daterange" range-separator="--"
              :clearable="clear" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="5" :offset="7" style="text-align:right;">
          <el-form-item>
            <el-button type="primary" @click="onSubmit" class="btn btnSubmit">查询</el-button>
            <el-button @click="resetForm()" class="btn btnReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      clear: false,
      form: {
        range: [],
        id: '',
        type: '',
        payType: '0',
        start: '',
        end: '',
        amount: '',
        userName: '',
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  methods: {
    onSubmit () {
      this.$emit('billSearch', this.form)
    },
    handleTimeChange () {
      this.$emit('timeChange', this.form)
    },
    resetForm () {
      this.form = {
        range: [],
        id: '',
        type: '',
        start: '',
        payType: '0',
        end: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../style/mixin";

.tradeSearch {
  width: 100%;
  // border: 1px solid #eee;
  // margin-top: 10px;
  // padding-top: 20px;
  // margin-left: 30px;
  @include flex-row;
}

.tradeSearch-form {
  width: 100%;
  margin-left: 30px;
  margin-top: 28px;
  font-size: 14px;
  color: #babfc2;
}

.line {
  text-align: center;
}

.btn {
  width: 80px;
  height: 36px;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
}

.btnSubmit {
  background-color: #2ecc72;
}

.btnReset {
  background-color: #cdcdcd;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/TradeSearch.vue